import { motion } from 'framer-motion';
import styled from 'styled-components';

export const SnackbarWrapper = styled(motion.div)`
    background: ${({ theme }) => theme.shades.white['20']};
    // TODO: Use of 'backdrop-filter' should be wrapped with '@supports'.
    backdrop-filter: blur(40px);
    border-radius: 12px;
    z-index: 500;
    height: 64px;
    width: 360px;
    position: fixed;
    bottom: 32px;
    display: flex;
    place-items: center;
    justify-content: center;
    left: calc(50% - 180px);
    column-gap: 20px;
    cursor: pointer;

    svg {
        width: 20px;
        height: 20px;
    }
`;
